// extracted by mini-css-extract-plugin
export default {"header_navigation":"styles_header_navigation__J-MOr","header_navigation_link":"styles_header_navigation_link__M5Uxj"};